import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {fetchAveragePricesBySlug} from "../api/fetch_average_prices";
import {fetchDistrictAveragePricesBySlug} from "../api/fetch_district_average_prices";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import {DistrictAveragePrices} from "../types/DistrictAveragePrices";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {getDistrictDisplayData} from "../utils/get_district_display_data";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";

const FETCH_REPORT_PRICE_AVERAGE_PRICES = "reports/FETCH_REPORT_PRICE_AVERAGE_PRICES";

export const fetchReportPriceAveragePricesTypes = createRequestActionTypes(FETCH_REPORT_PRICE_AVERAGE_PRICES);

// The district-level BigData endpoint never returns available_offers/median_price_m2 (checked across
// several cities/months - the fields just aren't there, same scenario or not), so these two always stay
// zeroed/null. Everything else (avg_price, per-room avg_price_m2_*) now comes from the same "rp-avg"
// scenario the city query uses, instead of the poorer "rp-price-avg" that only had avg_price_m2.
const toDistrictAveragePrices = (districtData: DistrictAveragePrices, citySlug: string): IPriceReportAveragePrices => ({
    date: districtData.date,
    city: citySlug,
    slug_city: citySlug,
    available_offers: 0,
    avg_price: Math.ceil(Number(districtData.avg_price)),
    avg_price_m2: districtData.avg_price_m2,
    avg_price_m2_studio: districtData.avg_price_m2_studio,
    avg_price_m2_2_rooms: districtData.avg_price_m2_2_rooms,
    avg_price_m2_3_rooms: districtData.avg_price_m2_3_rooms,
    avg_price_m2_4_plus_rooms: districtData.avg_price_m2_4_plus_rooms,
    median_price_m2: null
});

export const fetchReportPriceAveragePrices =
    (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
        dispatch({type: fetchReportPriceAveragePricesTypes.start});

        const pricesAvailableDate = getState().report.price.pricesAvailableDate;
        const citySlug = ctx.match.params.regionSlug;
        const district = getState().report.price.district;
        const date = getPricesAvailableDate(pricesAvailableDate?.date);

        if (district) {
            const query = {
                // First day of month, 13 months ago, format yyyy-mm-dd
                date_start: formatISO(sub(setDate(date, 1), {months: 13}), {representation: "date"}),
                // Last day of month before date, format yyyy-mm-dd
                date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
                scenario: "rp-avg",
                slug_city: citySlug,
                slug_district: getDistrictDisplayData(district, citySlug).slug,
                offer_type: getTypeForFetch(PricesViewType.FLATS)
            };

            const districtsData = await fetchDistrictAveragePricesBySlug(query);
            const prices = districtsData.map((item) => toDistrictAveragePrices(item, citySlug));

            dispatch({type: fetchReportPriceAveragePricesTypes.success, result: prices});

            return prices;
        }

        const query = {
            // First day of month, 13 months ago, format yyyy-mm-dd
            date_start: formatISO(sub(setDate(date, 1), {months: 13}), {representation: "date"}),
            // Last day of month before date, format yyyy-mm-dd
            date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
            scenario: "rp-avg",
            slug_city: citySlug,
            offer_type: getTypeForFetch(PricesViewType.FLATS)
        };

        const prices = await fetchAveragePricesBySlug(query);

        if (prices) {
            dispatch({type: fetchReportPriceAveragePricesTypes.success, result: prices});

            return prices;
        }

        dispatch(rpEnable404ResponseState(ctx.route.pathname));

        return false;
    };
import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {fetchAveragePricesBySlug} from "../api/fetch_average_prices";
import {fetchDistrictAveragePricesBySlug} from "../api/fetch_district_average_prices";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import {DistrictAveragePrices} from "../types/DistrictAveragePrices";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {getDistrictDisplayData} from "../utils/get_district_display_data";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";

const FETCH_REPORT_PRICE_AVERAGE_PRICES = "reports/FETCH_REPORT_PRICE_AVERAGE_PRICES";

export const fetchReportPriceAveragePricesTypes = createRequestActionTypes(FETCH_REPORT_PRICE_AVERAGE_PRICES);

// The district-level BigData endpoint never returns available_offers/median_price_m2 (checked across
// several cities/months - the fields just aren't there, same scenario or not), so these two always stay
// zeroed/null. Everything else (avg_price, per-room avg_price_m2_*) now comes from the same "rp-avg"
// scenario the city query uses, instead of the poorer "rp-price-avg" that only had avg_price_m2.
const toDistrictAveragePrices = (districtData: DistrictAveragePrices, citySlug: string): IPriceReportAveragePrices => ({
    date: districtData.date,
    city: citySlug,
    slug_city: citySlug,
    available_offers: 0,
    avg_price: Math.ceil(Number(districtData.avg_price)),
    avg_price_m2: districtData.avg_price_m2,
    avg_price_m2_studio: districtData.avg_price_m2_studio,
    avg_price_m2_2_rooms: districtData.avg_price_m2_2_rooms,
    avg_price_m2_3_rooms: districtData.avg_price_m2_3_rooms,
    avg_price_m2_4_plus_rooms: districtData.avg_price_m2_4_plus_rooms,
    median_price_m2: null
});

export const fetchReportPriceAveragePrices =
    (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
        dispatch({type: fetchReportPriceAveragePricesTypes.start});

        const pricesAvailableDate = getState().report.price.pricesAvailableDate;
        const citySlug = ctx.match.params.regionSlug;
        const district = getState().report.price.district;
        const date = getPricesAvailableDate(pricesAvailableDate?.date);

        if (district) {
            const query = {
                // First day of month, 13 months ago, format yyyy-mm-dd
                date_start: formatISO(sub(setDate(date, 1), {months: 13}), {representation: "date"}),
                // Last day of month before date, format yyyy-mm-dd
                date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
                scenario: "rp-avg",
                slug_city: citySlug,
                slug_district: getDistrictDisplayData(district, citySlug).slug,
                offer_type: getTypeForFetch(PricesViewType.FLATS)
            };

            const districtsData = await fetchDistrictAveragePricesBySlug(query);
            const prices = districtsData.map((item) => toDistrictAveragePrices(item, citySlug));

            dispatch({type: fetchReportPriceAveragePricesTypes.success, result: prices});

            return prices;
        }

        const query = {
            // First day of month, 13 months ago, format yyyy-mm-dd
            date_start: formatISO(sub(setDate(date, 1), {months: 13}), {representation: "date"}),
            // Last day of month before date, format yyyy-mm-dd
            date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
            scenario: "rp-avg",
            slug_city: citySlug,
            offer_type: getTypeForFetch(PricesViewType.FLATS)
        };

        const prices = await fetchAveragePricesBySlug(query);

        if (prices) {
            dispatch({type: fetchReportPriceAveragePricesTypes.success, result: prices});

            return prices;
        }

        dispatch(rpEnable404ResponseState(ctx.route.pathname));

        return false;
    };
